import ServicesNav from "components/services/ServicesNav";


const ServicesTypePage = () => {
  return <ServicesNav />;
};

export default ServicesTypePage;
